// Commons discovery categories — single source of truth.
//
// A category is a purely-discovery attribute of a project. It does NOT
// change project mechanics, status, commitments, requirements, Roots,
// or invitation behavior. All six categories share the same underlying
// Commons protocol; they are lenses, not project types.
//
// Adding/renaming/removing a category is a coordinated change:
//   • update CATEGORIES here (id must remain stable — it lives in
//     `project.category` in the database),
//   • ensure any project in seed.json referencing an old id is
//     migrated.

export const CATEGORIES = [
  {
    id: "gather",
    emoji: "🎉",
    name: "Gather & Celebrate",
    descriptor: "Parties, festivals, adventures…",
    // Accent colors used only for the tile treatment on Home and the
    // header on Category pages. Not applied to project cards inside.
    accent: "#F1B76A", // warm honey
    surface: "#FBECD1",
    ink: "#5A3E10",
  },
  {
    id: "improve",
    emoji: "🏘",
    name: "Improve Our Communities",
    descriptor: "Repair, build, care for a place…",
    accent: "#7A8B4F",
    surface: "#E8ECD5",
    ink: "#3B4322",
  },
  {
    id: "change",
    emoji: "📣",
    name: "Change Something",
    descriptor: "Campaigns, actions, civic experiments…",
    accent: "#B25A7A",
    surface: "#F3DFE6",
    ink: "#4E2033",
  },
  {
    id: "make",
    emoji: "🎨",
    name: "Make Something",
    descriptor: "Art, music, things made together…",
    accent: "#C58230",
    surface: "#F6E1C6",
    ink: "#4B2C0D",
  },
  {
    id: "help",
    emoji: "🌱",
    name: "Help & Care",
    descriptor: "Neighbors helping neighbors…",
    accent: "#6B8E68",
    surface: "#DEE9DA",
    ink: "#2B4028",
  },
  {
    id: "wild",
    emoji: "🚀",
    name: "Try Something Wild",
    descriptor: "Moonshots, experiments, delightful ambition…",
    accent: "#6E6FA6",
    surface: "#E3E4F1",
    ink: "#2C2D55",
  },
];

export const CATEGORY_BY_ID = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c])
);

export const isValidCategoryId = (id) => !!CATEGORY_BY_ID[id];
